export default "__VITE_ASSET__KqwxZT8r__"